let UTILS = require("../libs/utils.js");
var v7694;
var v7695;
module.exports = {
  id: "simon",
  name: "Simon Says",
  alias: "simon",
  endStats: ["sid", "name", "score", "reward"],
  condition: [function (game) {
    var vLN01185 = 0;
    for (var vLN01186 = 0; vLN01186 < game.players.list.length; ++vLN01186) {
      if (game.players.list[vLN01186].active && game.players.list[vLN01186].team == 1) {
        vLN01185++;
      }
    }
    return vLN01185 > 0;
  }],
  minPlayers: 3,
  waitTimers: [{
    time: 10000,
    msg: "starts in ",
    trigger: function (p9094) {
      p9094.pickSimon();
    }
  }],
  teams: true,
  viewDis: 1000,
  teamOptions: ["Followers", "Simon"],
  noKick: true,
  teamSee: ["Followers", "Simon"]
};